import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // Initialize i18n before rendering
import AppRouter from './router';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { captureUtmParams } from './utils/utmCapture';

// Capture UTM parameters from marketing campaigns on first visit
captureUtmParams();

// Note: @capacitor-firebase/authentication doesn't require manual initialization
// It uses the GoogleService-Info.plist (iOS) / google-services.json (Android) for config

// Configure StatusBar for native platforms
if (Capacitor.isNativePlatform()) {
  // Prevent WebView content from rendering behind status bar (Android fix)
  StatusBar.setOverlaysWebView({ overlay: false }).catch(() => {});
  StatusBar.setStyle({ style: Style.Light }).catch(() => {
    // Ignore errors - StatusBar may not be available on all platforms
  });
  StatusBar.setBackgroundColor({ color: '#ffffff' }).catch(() => {
    // Android only - ignore on iOS
  });
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);
